<div class="panel-content demiPanel">
  <div class="share-mode">
    <p>Define an area to download USGS elevation data as a single geotiff file.</p>
  </div>
  <div class="button-containerTop">
    <img [ngClass]="isActive ? 'drawImage' : 'drawImg'" src="../../../../../../assets/img/dem/dem_box_icon_v1.png" (click)="drawBox()" alt="area_icon">
    <span class="panel-text-box">New coverage area</span><br />
  </div>
  <div class="dem-area" *ngIf="drawPolygon">
    <ul>
      <li>
        <label>Coverage Size</label>
        <p>{{coverageSize}} ac</p>
      </li>
      <li>
        <label>Coordinates (Centroid)</label>
        <p>{{centroidCoordinate}}</p>
      </li>
      <li>
        <label>Horizontal Resolution</label>
        <p>{{horixentalResolution}}m</p>
      </li>
      <li>
        <label>Vertical Resolution</label>
        <p>{{verticalResolution}}in</p>
      </li>
      <li>
        <label>Output Dimensions</label>
        <p>{{outputDimmensions}}</p>
      </li>
      <li>
        <label>Coordinate System</label>
        <p>Web Mercator EPSG:3857</p>
      </li>
      <li>
        <label>Estimated File Size</label>
        <p>{{estimateSize}}</p>
      </li>
    </ul>

    <button *ngIf="drawPolygon" [disabled]="isDisabled" (click)="go()"  class="submit" style="margin-left: 10px;">GO</button>
  </div>
  <div *ngIf="!drawPolygon">
    <ng-container *ngIf="processingStart">
      <div class="download-file" >
        <div class="title">
          <label>{{saveViewTitle}}</label>
          <p>{{coverageSize}} ac</p>
        </div>
        <div class="processing">
          <a class=""  *ngIf="!readyToDownload">
            <img [tooltip]="processingTip" [options]="myprocessing"  alt="loader" src="../../../../../../assets/img/wheel.svg">
          </a>


          <a [tooltip]="downloadTip" [options]="myDownload">
            <img *ngIf="readyToDownload" (click)="downloadTiffFile(demFileName)" alt="loader" src="../../../../../../assets/img/dem-download.svg">
            <p *ngIf="readyToDownload">{{estimateSize}}</p>
          </a>

        </div>
      </div>
      <div>
        <p class="status" *ngIf="!readyToDownload">Processing</p>
        <p class="status" *ngIf="readyToDownload">File Ready</p>
      </div>
    </ng-container>

    <ng-container *ngFor="let item of allDemFiles">
      <ul class="dem-data" [ngClass]="item.id === demService.selectedId ? 'my-list-item' : ''">
        <li>
          <div class="file-list" (click)="clickOnFeature(item)">
            <div class="title">
              <label>{{ item.name }}</label>
              <p class="file-size">{{item.coverage_size}} ac</p>
            </div>
            <div class="processing"  [tooltip]="downloadTip" [options]="myDownload">
              <img alt="loader" (click)="downloadTiffFile(item.tiff_filename)" src="../../../../../../assets/img/dem-download.svg">
              <p>{{item.estimated_file_size}}</p>
            </div>
          </div>
        </li>
        <li>
      </ul>
    </ng-container>

  </div>
</div>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img (click)="closeLeft()" class="closer-img common-btns tool-toolTip" src="/assets/img/tools/close-pv3.png"
      alt="closer" /><span class="tooltiptext tip-bottom"
      [innerHtml]="mapServices.templatetoolTips['close_left_panel']"></span>
  </a>
</div>
<!-- <ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <p class="loading" > <img src="/assets/img/wheel.svg" alt="Girl in a jacket" width="50px" height="50px" > </p>
  </ngx-spinner> -->
